import api from '@/api/axios'

export default {
  namespaced: true,
  state: () => ({
    //upload state
    isUploading: false,
    uploadError: null,
    uploadSuccess: false,
    //crawling state
    isProcessing: false,
    processingError: null,
  }),
  mutations: {
    SET_IS_UPLOADING(state, value) {
      state.isUploading = value
    },
    SET_UPLOAD_ERROR(state, error) {
      state.uploadError = error
    },
    SET_UPLOAD_SUCCESS(state, value) {
      state.uploadSuccess = value
    },
    SET_IS_PROCESSING(state, value) {
      state.isProcessing = value
    },
    SET_PROCESSING_ERROR(state, error) {
      state.processingError = error
    },
  },
  actions: {
    async uploadLucyFile({ commit }, { file }) {
      commit('SET_IS_UPLOADING', true)
      commit('SET_UPLOAD_ERROR', null)
      commit('SET_UPLOAD_SUCCESS', false)

      try {
        const formData = new FormData()
        formData.append('file', file)
        
        const response = await api.post('/api/v1/crawling/upload-lucy', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })

        if (response.data.success) {
          commit('SET_UPLOAD_SUCCESS', true)
        } else {
          throw new Error(response.data.message || '파일 업로드에 실패했습니다.')
        }
      } catch (error) {
        console.error('Failed to upload file:', error)
        commit('SET_UPLOAD_ERROR', error.message || '파일 업로드 중 오류가 발생했습니다.')
      } finally {
        commit('SET_IS_UPLOADING', false)
      }
    },
    
    async createRealtimeCrawler({ commit }, {
      project_id,
      job_name,
      keywords,
      excluded_keywords,
      frequency,
      channels,
      mode,
      alert_threshold,
      start_date,
      end_date
    }) {
      commit('SET_IS_PROCESSING', true)
      commit('SET_PROCESSING_ERROR', null)

      try {
        const formData = new FormData()
        formData.append('project_id', project_id)
        formData.append('job_name', job_name)
        
        // Keywords must be sent as a list
        keywords.forEach(keyword => {
          formData.append('keywords', keyword)
        })
        
        // Add excluded keywords if they exist
        if (excluded_keywords && excluded_keywords.length > 0) {
          excluded_keywords.forEach(keyword => {
            formData.append('excluded_keywords', keyword)
          })
        }
        
        formData.append('frequency', frequency)
        
        // Channels must be sent as a list
        channels.forEach(channel => {
          formData.append('channels', channel)
        })
        
        formData.append('mode', mode)
        
        if (alert_threshold) {
          formData.append('alert_threshold', alert_threshold)
        }
        
        formData.append('start_date', start_date)
        formData.append('end_date', end_date)
        
        const response = await api.post('/api/v1/crawling/create-realtime-crawler', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })

        if (response.data.success) {
          return response.data
        } else {
          throw new Error(response.data.message || '실시간 크롤링 등록에 실패했습니다.')
        }
      } catch (error) {
        console.error('Failed to create realtime crawler:', error)
        commit('SET_PROCESSING_ERROR', error.message || '실시간 크롤링 등록 중 오류가 발생했습니다.')
        throw error
      } finally {
        commit('SET_IS_PROCESSING', false)
      }
    },
    
    async startCrawling({ commit }, {file, selected_project_id}) {
      commit('SET_IS_PROCESSING', true)
      commit('SET_PROCESSING_ERROR', null)

      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('selected_project_id', selected_project_id.toString())
        console.log('FormData contents:')
        for (let [key, value] of formData.entries()) {
          console.log(key, value)
        }
        const response = await api.post('/api/v1/crawling/start-crawling', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })

        if (response.data.success) {
          return response.data
        } else {
          throw new Error(response.data.message || '크롤링 시작에 실패했습니다.')
        }
      } catch (error) {
        commit('SET_PROCESSING_ERROR', error.message || '크롤링 시작 중 오류가 발생했습니다.')
        throw error
      } finally {
        commit('SET_IS_PROCESSING', false)
      }
    },
    
    async updateCrawlingJobName({ commit }, { jobId, jobName }) {
      commit('SET_IS_PROCESSING', true)
      commit('SET_PROCESSING_ERROR', null)

      try {
        const formData = new FormData()
        formData.append('job_name', jobName)
        const response = await api.put(`/api/v1/crawling/update-crawling-job-partial/${jobId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })

        if (response.data.success) {
          return response.data
        } else {
          throw new Error(response.data.message || '크롤링 작업 이름 업데이트에 실패했습니다.')
        }
      } catch (error) {
        commit('SET_PROCESSING_ERROR', error.message || '크롤링 작업 이름 업데이트 중 오류가 발생했습니다.')
        throw error
      } finally {
        commit('SET_IS_PROCESSING', false)
      }
    },
  },
  getters: {
    isUploading: state => state.isUploading,
    uploadError: state => state.uploadError,
    uploadSuccess: state => state.uploadSuccess,
    isProcessing: state => state.isProcessing,
    processingError: state => state.processingError,
  }
}
